module.exports = __webpack_public_path__ + "img/moov-1.6ec9d892.png";